module.exports = __webpack_public_path__ + "static/media/react.ab3a79b5.png";